export const FIELD_TYPE_MAP: Record<string, string> = {
    text: 'string',
    textarea: 'string',
    combo: 'string',
    radiogroup: 'string',
    user: 'id',
    combocheck: 'array',
    checkboxgroup: 'array',
    usergroup: 'idarray',
    number: 'number',
    datetime: 'datetime',
    address: 'address',
    location: 'location',
    dept: 'did',
    deptgroup: 'didarray',
    upload: 'upload',
    image: 'url',
    url: 'url',
    signature: 'signature',
    sn: 'string',
    phone: 'phone',
    aggregation: 'number',
    aggregationtext: 'string',
    company: 'string',
    account_pool: 'string',
    leads_pool: 'string',
    sale_stage: 'string'
};
